/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import { FormHeader } from '../../react/form_header.jsx';
import { FormInputGroup } from '../../react/form_input_group.jsx';
import { JsonBlob } from '../../react/json_blob.jsx';
import * as Actions from '../store/actions';
import { FormRow } from '../../react/form_row.jsx';
import { AttendeeQuestionListContainer as AttendeeQuestionList } from './attendee_question_list.jsx';
import { TicketGroupContainer as TicketGroup } from './ticket_group.jsx';
import { TicketList } from './ticket_list.jsx';
import { PromoCode as PromoCodeList } from './promo_code_list.jsx';

import React from 'react';
import ReactDOM from 'react-dom';
import * as ReactRedux from 'react-redux';
import * as ReactDnD from 'react-dnd';
import ReactDnDHTML5Backend from 'react-dnd-html5-backend';
import * as Reselect from 'reselect';
import _ from 'underscore';

    class Editor extends React.Component {
      constructor(props) {
        super(props);
        this._createIntersectionObserver = this._createIntersectionObserver.bind(this);
        this.componentDidMount = this.componentDidMount.bind(this);
        this.componentWillUnmount = this.componentWillUnmount.bind(this);
        this.onTicketChanged = this.onTicketChanged.bind(this);
        this.onTicketDeleted = this.onTicketDeleted.bind(this);
        this.onAddTicketClass = this.onAddTicketClass.bind(this);
        this.onTicketClassDragStart = this.onTicketClassDragStart.bind(this);
        this.onTicketClassDragFinish = this.onTicketClassDragFinish.bind(this);
        this.onTicketClassDragUpdate = this.onTicketClassDragUpdate.bind(this);
        this.onTicketClassDragCancel = this.onTicketClassDragCancel.bind(this);
        this.onToggleTicketEditor = this.onToggleTicketEditor.bind(this);
        this.onTicketGroupChanged = this.onTicketGroupChanged.bind(this);
        this.onTicketGroupDeleted = this.onTicketGroupDeleted.bind(this);
        this.onAddTicketGroup = this.onAddTicketGroup.bind(this);
        this.onTicketGroupDragStart = this.onTicketGroupDragStart.bind(this);
        this.onTicketGroupDragFinish = this.onTicketGroupDragFinish.bind(this);
        this.onTicketGroupDragUpdate = this.onTicketGroupDragUpdate.bind(this);
        this.onTicketGroupDragCancel = this.onTicketGroupDragCancel.bind(this);
        this.onToggleTicketGroupEditor = this.onToggleTicketGroupEditor.bind(this);
        this.onPromoCodeChanged = this.onPromoCodeChanged.bind(this);
        this.onPromoCodeDeleted = this.onPromoCodeDeleted.bind(this);
        this.onAddPromoCode = this.onAddPromoCode.bind(this);
        this.onPromoCodeAddTicketClass = this.onPromoCodeAddTicketClass.bind(this);
        this.onPromoCodeRemoveTicketClass = this.onPromoCodeRemoveTicketClass.bind(this);
        this.onTogglePromoCodeEditor = this.onTogglePromoCodeEditor.bind(this);
        this.onAttendeeQuestionChanged = this.onAttendeeQuestionChanged.bind(this);
        this.onAttendeeQuestionDeleted = this.onAttendeeQuestionDeleted.bind(this);
        this.onAddAttendeeQuestion = this.onAddAttendeeQuestion.bind(this);
        this.onAttendeeQuestionChoiceAdd = this.onAttendeeQuestionChoiceAdd.bind(this);
        this.onAttendeeQuestionChoiceChange = this.onAttendeeQuestionChoiceChange.bind(this);
        this.onAttendeeQuestionChoiceDelete = this.onAttendeeQuestionChoiceDelete.bind(this);
        this.onAttendeeQuestionChoiceDragStart = this.onAttendeeQuestionChoiceDragStart.bind(this);
        this.onAttendeeQuestionChoiceDragUpdate = this.onAttendeeQuestionChoiceDragUpdate.bind(this);
        this.onAttendeeQuestionChoiceDragFinish = this.onAttendeeQuestionChoiceDragFinish.bind(this);
        this.onAttendeeQuestionChoiceDragCancel = this.onAttendeeQuestionChoiceDragCancel.bind(this);
        this.onToggleQuestionEditor = this.onToggleQuestionEditor.bind(this);
        this.onAttendeeQuestionDragStart = this.onAttendeeQuestionDragStart.bind(this);
        this.onAttendeeQuestionDragFinish = this.onAttendeeQuestionDragFinish.bind(this);
        this.onAttendeeQuestionDragUpdate = this.onAttendeeQuestionDragUpdate.bind(this);
this.onAttendeeQuestionDragCancel = this.onAttendeeQuestionDragCancel.bind(this);

        // Set up initial state
        this.state = {
          // List of IDs of ticket editors that are opened
          openedTickets: [],
          // List of IDs of ticket group editors that are opened
          openedTicketGroups: [],
          // List of IDs of promo code editors that are opened
          openedPromoCodes: [],
          // List of IDs of question editors that are opened
          openedAttendeeQuestions: [],
          // Enable debugging
          debug: false,
          // Records whether the element is actually visible in the browser via IntersectionObserver
          // see _createIntersectionObserver
          isElementVisible: true,
          // The HTML to mirror when the component is not visible "hidden"
          hiddenHTML: null
        };

        this._createIntersectionObserver();
      }

      // This is the basis of a workaround for the editor breaking photo upload by dragging a file in
      // on the admin event editor
      //
      // The drag/drop components used inside this Editor capture events at too wide, covering the entire page,
      // and prevent the photo component (which is an entirely parallel React tree) from receiving a drop event.
      //
      // This works around it by hiding the actual ticket editor when it is not visible to the user, by monitoring
      // an IntersectionObserver to determine when it is visible.
      //
      // When the editor is hidden, a HTML-only copy of the editor markup is rendered, rather than real React markup.
      // This prevents a page "jump" when switching in Chrome and Firefox because the tab visibility switch occurs before
      // React re-renders the component with contents.
      //
      // In browsers that don't support IntersectionObserver (notably, Safari older than 12.1 and IE), this workaround is
      // not activated and upload by dragging is still broken.
      //
      // See also render and renderHidden
      _createIntersectionObserver() {
        // Create the intersection observer to observe for visibility changes of the component.
        // The element to monitor is managed through componentDidMount/componentWillUnmount
        if (typeof IntersectionObserver !== 'undefined') {
          return this._intersectionObserver = new IntersectionObserver(entries => {
            if (entries[0].intersectionRatio > 0) {
              // Our element is now visible
              return this.setState({
                isElementVisible: true,
                hiddenHTML: null
              });
            } 
              // Our element is now hidden, so capture the HTML that was displayed to use as a dummy copy.
              const element = ReactDOM.findDOMNode(this);
              return this.setState({
                isElementVisible: false,
                hiddenHTML: (element != null ? element.innerHTML : undefined)
              });
            
          });
        }
      }


      // Register for updates on our element's visibility
      componentDidMount() {
        const element = ReactDOM.findDOMNode(this);
        if (element) { return (this._intersectionObserver != null ? this._intersectionObserver.observe(element) : undefined); }
      }

      // Clean up observer registration
      componentWillUnmount() {
        const element = ReactDOM.findDOMNode(this);
        if (element) { return (this._intersectionObserver != null ? this._intersectionObserver.unobserve(element) : undefined); }
      }


      onTicketChanged(ticket_id, name, value, event) {
        return this.props.ticketChanged(ticket_id, name, value);
      }

      onTicketDeleted(ticket_id, event) {
        return this.props.removeTicketClass(ticket_id);
      }

      onAddTicketClass(event) {
        const new_ticket = this.props.addTicketClass();
        this.setState({openedTickets: [new_ticket.payload.id]});
        return event.preventDefault();
      }

      onTicketClassDragStart(item) {
        return this.props.ticketClassDragStart(item);
      }

      onTicketClassDragFinish(item) {
        return this.props.ticketClassDragFinish(item);
      }

      onTicketClassDragUpdate(item, target_id, target_position, target_group) {
        return this.props.ticketClassDragUpdate(item, target_id, target_position, target_group);
      }

      onTicketClassDragCancel(item) {
        return this.props.ticketClassDragCancel(item);
      }

      // Toggle the visible state of the editor for +ticket_id+
      onToggleTicketEditor(ticket_id, state) {
        let new_opened_tickets;
        if (state == null) { state = undefined; }
        if ((state !== true) && (this.state.openedTickets.indexOf(ticket_id) > -1)) {
          // Close it
          new_opened_tickets = _.reject(this.state.openedTickets, i => i === ticket_id);
        } else {
          // Open it
          new_opened_tickets = this.state.openedTickets.slice();
          new_opened_tickets.push(ticket_id);
        }

        return this.setState({openedTickets: new_opened_tickets});
      }


      onTicketGroupChanged(ticket_group_id, name, value, event) {
        return this.props.ticketGroupChanged(ticket_group_id, name, value);
      }

      onTicketGroupDeleted(ticket_group_id, event) {
        return this.props.removeTicketGroup(ticket_group_id);
      }

      onAddTicketGroup(event) {
        const new_ticket_group = this.props.addTicketGroup();
        this.setState({openedTicketGroups: [new_ticket_group.payload.id]});
        return event.preventDefault();
      }

      onTicketGroupDragStart(item) {
        return this.props.ticketGroupDragStart(item);
      }

      onTicketGroupDragFinish(item) {
        return this.props.ticketGroupDragFinish(item);
      }

      onTicketGroupDragUpdate(item, target_position) {
        return this.props.ticketGroupDragUpdate(item, target_position);
      }

      onTicketGroupDragCancel(item) {
        return this.props.ticketGroupDragCancel(item);
      }

      // Toggle the visible state of the editor for +ticket_group_id+
      onToggleTicketGroupEditor(ticket_group_id, state) {
        let new_opened_ticket_groups;
        if (state == null) { state = undefined; }
        if ((state !== true) && (this.state.openedTicketGroups.indexOf(ticket_group_id) > -1)) {
          // Close it
          new_opened_ticket_groups = _.reject(this.state.openedTicketGroups, i => i === ticket_group_id);
        } else {
          // Open it
          new_opened_ticket_groups = this.state.openedTicketGroups.slice();
          new_opened_ticket_groups.push(ticket_group_id);
        }

        return this.setState({openedTicketGroups: new_opened_ticket_groups});
      }


      onPromoCodeChanged(promo_code_id, name, value, event) {
        return this.props.promoCodeChanged(promo_code_id, name, value);
      }

      onPromoCodeDeleted(promo_code_id, event) {
        return this.props.removePromoCode(promo_code_id);
      }

      onAddPromoCode(event) {
        const new_promo_code = this.props.addPromoCode();
        this.setState({openedPromoCodes: [new_promo_code.payload.id]});
        return event.preventDefault();
      }

      onPromoCodeAddTicketClass(promo_code_id, ticket_class_id) {
        return this.props.addPromoCodeTicketClass(promo_code_id, ticket_class_id);
      }

      onPromoCodeRemoveTicketClass(promo_code_id, ticket_class_id) {
        return this.props.removePromoCodeTicketClass(promo_code_id, ticket_class_id);
      }

      // Toggle the visible state of the editor for +promo_code_id+
      onTogglePromoCodeEditor(promo_code_id, state) {
        let newOpenedPromoCodes;
        if (state == null) { state = undefined; }
        if ((state !== true) && (this.state.openedPromoCodes.indexOf(promo_code_id) > -1)) {
          // Close it
          newOpenedPromoCodes = _.reject(this.state.openedPromoCodes, i => i === promo_code_id);
        } else {
          // Open it
          newOpenedPromoCodes = this.state.openedPromoCodes.slice();
          newOpenedPromoCodes.push(promo_code_id);
        }

        return this.setState({openedPromoCodes: newOpenedPromoCodes});
      }


      onAttendeeQuestionChanged(question_id, name, value, event) {
        return this.props.attendeeQuestionChanged(question_id, name, value);
      }

      onAttendeeQuestionDeleted(question_id, event) {
        return this.props.removeAttendeeQuestion(question_id);
      }

      onAddAttendeeQuestion(event) {
        const new_question = this.props.addAttendeeQuestion();
        this.setState({openedAttendeeQuestions: [new_question.payload.id]});
        return event.preventDefault();
      }

      onAttendeeQuestionChoiceAdd(question_id, event) {
        event.preventDefault();
        return this.props.addAttendeeQuestionChoice(question_id);
      }

      onAttendeeQuestionChoiceChange(question_id, index, value, event) {
        return this.props.changeAttendeeQuestionChoice(question_id, index, value);
      }

      onAttendeeQuestionChoiceDelete(question_id, index) {
        return this.props.removeAttendeeQuestionChoice(question_id, index);
      }

      onAttendeeQuestionChoiceDragStart(question_id, item) {
        return this.props.attendeeQuestionChoiceDragStart(question_id, item);
      }

      onAttendeeQuestionChoiceDragUpdate(question_id, item, index) {
        return this.props.attendeeQuestionChoiceDragUpdate(question_id, item, index);
      }

      onAttendeeQuestionChoiceDragFinish(question_id, result, item) {
        return this.props.attendeeQuestionChoiceDragFinish(question_id, result, item);
      }

      onAttendeeQuestionChoiceDragCancel(question_id, item) {
        return this.props.attendeeQuestionChoiceDragCancel(question_id, item);
      }

      // Toggle the visible state of the editor for +attendee_question_id+
      onToggleQuestionEditor(attendee_question_id, state) {
        let newOpenedQuestions;
        if (state == null) { state = undefined; }
        if ((state !== true) && (this.state.openedAttendeeQuestions.indexOf(attendee_question_id) > -1)) {
          // Close it
          newOpenedQuestions = _.reject(this.state.openedAttendeeQuestions, i => i === attendee_question_id);
        } else {
          // Open it
          newOpenedQuestions = this.state.openedAttendeeQuestions.slice();
          newOpenedQuestions.push(attendee_question_id);
        }

        return this.setState({openedAttendeeQuestions: newOpenedQuestions});
      }

      onAttendeeQuestionDragStart(item) {
        return this.props.attendeeQuestionDragStart(item);
      }

      onAttendeeQuestionDragFinish(item) {
        return this.props.attendeeQuestionDragFinish(item);
      }

      onAttendeeQuestionDragUpdate(item, target_position) {
        return this.props.attendeeQuestionDragUpdate(item, target_position);
      }

      onAttendeeQuestionDragCancel(item) {
        return this.props.attendeeQuestionDragCancel(item);
      }


      // Render the editor appropriately, based on the element's visibility
      render() {
        if (this.state.isElementVisible) {
          return this.renderEditor();
        } 
          return this.renderHidden();
        
      }

      // Render the hidden version of the editor, which is the previously-rendered editor's HTML only, without
      // any event handlers.
      //
      // This must use dangerouslySetInnerHTML in order for the HTML to be rendered as HTML and not escaped text.
      renderHidden() { return <div className="ticket-editor--editor" dangerouslySetInnerHTML={{__html: this.state.hiddenHTML}} />; }

      // Render the editor in its normal, visible state.
      renderEditor() {
        const default_group_table = <TicketGroup key="default"
                                            debug={this.state.debug}
                                            header={false}
                                            tableHeader={true}
                                            canMove={false}
                                            canRemove={false}
                                            tickets={this.props.groupedTickets['default']}
                                            haveNoTickets={this.props.haveNoTickets}
                                            openedEditors={this.state.openedTickets}
                                            openedGroupEditors={this.state.openedTicketGroups}
                                            settings={this.props.settings}
                                            onToggleTicketEditor={this.onToggleTicketEditor}
                                            onToggleTicketGroupEditor={this.onToggleTicketGroupEditor}
                                            onAddTicketClass={this.onAddTicketClass}
                                            onTicketChange={this.onTicketChanged}
                                            onTicketDelete={this.onTicketDeleted}
                                            onTicketDragStart={this.onTicketClassDragStart}
                                            onTicketDragFinish={this.onTicketClassDragFinish}
                                            onTicketDragUpdate={this.onTicketClassDragUpdate}
                                            onTicketDragCancel={this.onTicketClassDragCancel}
                                            onGroupChange={this.onTicketGroupChanged}
                                            onGroupDelete={this.onTicketGroupDeleted}
                                            onGroupDragStart={this.onTicketGroupDragStart}
                                            onGroupDragFinish={this.onTicketGroupDragFinish}
                                            onGroupDragUpdate={this.onTicketGroupDragUpdate}
                                            onGroupDragCancel={this.onTicketGroupDragCancel} />;

        const group_tables = [default_group_table].concat((
          Array.from(this.props.ticketGroups).map((group) =>
            <TicketGroup key={group.id}
                          debug={this.state.debug}
                          header={true}
                          tableHeader={false}
                          ticketGroup={group}
                          tickets={this.props.groupedTickets[group.id]}
                          openedEditors={this.state.openedTickets}
                          showGroupEditor={this.state.openedTicketGroups.indexOf(group.id) > -1}
                          settings={this.props.settings}
                          onToggleTicketEditor={this.onToggleTicketEditor}
                          onToggleTicketGroupEditor={this.onToggleTicketGroupEditor}
                          onTicketChange={this.onTicketChanged}
                          onTicketDelete={this.onTicketDeleted}
                          onTicketDragStart={this.onTicketClassDragStart}
                          onTicketDragFinish={this.onTicketClassDragFinish}
                          onTicketDragUpdate={this.onTicketClassDragUpdate}
                          onTicketDragCancel={this.onTicketClassDragCancel}
                          onGroupChange={this.onTicketGroupChanged}
                          onGroupDelete={this.onTicketGroupDeleted}
                          onGroupDragStart={this.onTicketGroupDragStart}
                          onGroupDragFinish={this.onTicketGroupDragFinish}
                          onGroupDragUpdate={this.onTicketGroupDragUpdate}
                          onGroupDragCancel={this.onTicketGroupDragCancel} />)
        )
        );

        return <div className="ticket-editor--editor">
          <FormInputGroup>
            <FormHeader title="Tickets" labelFor="#invalid">
              <div className="action_button pull-right">
                <button title="Use separators to organize different categories of tickets"
                        className="btn btn-color" onClick={this.onAddTicketGroup}><i className="localist-icon-add-small"
                                                                                     aria-label="Add" /> Ticket Type
                </button>
                {' '}
                <button className="btn btn-color" onClick={this.onAddTicketClass}><i className="localist-icon-add-small"
                                                                                     aria-label="Add" /> Ticket
                </button>
              </div>
            </FormHeader>
          </FormInputGroup>

          <fieldset className="ticket-groups-wrapper">
            {group_tables}
          </fieldset>

          <FormInputGroup>
            <FormHeader title="Promo Codes" className="" labelFor="#invalid">
              <div className="action_button pull-right">
                <button className="btn btn-color" onClick={this.onAddPromoCode}><i className="localist-icon-add-small"
                                                                                   aria-label="Add" /> Promo Code
                </button>
              </div>
            </FormHeader>
          </FormInputGroup>

          <PromoCodeList promoCodes={this.props.promoCodes}
                         settings={this.props.settings}
                         availableTicketClasses={this.props.availableTicketClasses}
                         openedEditors={this.state.openedPromoCodes}
                         onChange={this.onPromoCodeChanged}
                         onDelete={this.onPromoCodeDeleted}
                         onToggleEditor={this.onTogglePromoCodeEditor}
                         onAddPromoCode={this.onAddPromoCode}
                         onAddTicketClass={this.onPromoCodeAddTicketClass}
                         onRemoveTicketClass={this.onPromoCodeRemoveTicketClass} />

          <FormInputGroup>
            <FormHeader title="Attendee Questions" className="" labelFor="#invalid">
              <div className="action_button pull-right">
                <button className="btn btn-color" onClick={this.onAddAttendeeQuestion}><i
                  className="localist-icon-add-small" aria-label="Add" /> Attendee Question
                </button>
              </div>
            </FormHeader>
          </FormInputGroup>

          <AttendeeQuestionList defaultQuestions={this.props.defaultQuestions}
                                questions={this.props.questions}
                                settings={this.props.settings}
                                openedEditors={this.state.openedAttendeeQuestions}
                                onDragStart={this.onAttendeeQuestionDragStart}
                                onDragUpdate={this.onAttendeeQuestionDragUpdate}
                                onDragFinish={this.onAttendeeQuestionDragFinish}
                                onDragCancel={this.onAttendeeQuestionDragCancel}
                                onToggleEditor={this.onToggleQuestionEditor}
                                onAddAttendeeQuestion={this.onAddAttendeeQuestion}
                                onChange={this.onAttendeeQuestionChanged}
                                onDelete={this.onAttendeeQuestionDeleted}
                                onChoiceAdd={this.onAttendeeQuestionChoiceAdd}
                                onChoiceChange={this.onAttendeeQuestionChoiceChange}
                                onChoiceDelete={this.onAttendeeQuestionChoiceDelete}
                                onChoiceDragStart={this.onAttendeeQuestionChoiceDragStart}
                                onChoiceDragUpdate={this.onAttendeeQuestionChoiceDragUpdate}
                                onChoiceDragFinish={this.onAttendeeQuestionChoiceDragFinish}
                                onChoiceDragCancel={this.onAttendeeQuestionChoiceDragCancel} />

          <JsonBlob name="ticket_data[ticket_groups]" value={this.props.allTicketGroups} />
          <JsonBlob name="ticket_data[ticket_classes]" value={this.props.allTickets} />
          <JsonBlob name="ticket_data[promo_codes]" value={this.props.allPromoCodes} />
          <JsonBlob name="ticket_data[attendee_questions]" value={this.props.allQuestions} />
        </div>;
      }
    }

    const selectors = {
      ticketGroups(state) { return state.ticket_groups; },
      ticketClasses(state) { return state.ticket_classes; },
      promoCodes(state) { return state.promo_codes; },
      attendeeQuestions(state) { return state.attendee_questions; },
      defaultAttendeeQuestions(state) { return state.default_attendee_questions; },
      settings(state) { return state.settings; }
    };

    // Fee settings
    selectors.feeSettings = Reselect.createSelector(selectors.settings, settings => settings.fees);

    // Not-deleted ticket classes
    selectors.notDeletedTicketClasses = Reselect.createSelector(selectors.ticketClasses, ticketClasses => _.reject(ticketClasses, {delete: true}));

    // Not-deleted ticket groups
    selectors.notDeletedTicketGroups = Reselect.createSelector(selectors.ticketGroups, ticketGroups => _.reject(ticketGroups, {delete: true}));

    selectors.sortedTicketGroups = Reselect.createSelector(selectors.notDeletedTicketGroups, ticketGroups => _.sortBy(ticketGroups, 'position'));

    // Not deleted promo codes
    selectors.notDeletedPromoCodes = Reselect.createSelector(selectors.promoCodes, promoCodes => _.reject(promoCodes, {delete: true}));

    // Not deleted attendee questions
    selectors.notDeletedAttendeeQuestions = Reselect.createSelector(selectors.attendeeQuestions, questions => _.reject(questions, {delete: true}));

    // Group the available ticket classes into a default group, and one for each ticket group defined
    //
    // Returns {group_id: [ticket_classes]}
    selectors.ticketsByGroup = Reselect.createSelector(selectors.notDeletedTicketGroups, selectors.notDeletedTicketClasses, function(ticketGroups, ticketClasses) {
      const result = {default: []};
      const tickets_by_id = _.indexBy(ticketClasses, 'id');

      // Defined groups
      for (const group of Array.from(ticketGroups)) {
        result[group.id] = _.compact(Array.from(group.ticket_class_ids).map((ticket_id) => tickets_by_id[ticket_id]));
        result[group.id] = _.sortBy(result[group.id], 'position');
      }

      result['default'] = _.sortBy(_.select(ticketClasses, ticket_class => !ticket_class.ticket_group_id), 'position');
      return result;
    });

    selectors.sortedAttendeeQuestions = Reselect.createSelector(selectors.notDeletedAttendeeQuestions, questions => _.sortBy(questions, 'position'));

    // True if there's no ticket classes or groups defined
    selectors.haveNoTickets = Reselect.createSelector(selectors.notDeletedTicketClasses, selectors.notDeletedTicketGroups,
      (ticket_classes, ticket_groups) => (ticket_classes.length === 0) && (ticket_groups.length === 0));


    const mapStateToProps = state => ({
      allTickets: selectors.ticketClasses(state),
      availableTicketClasses: selectors.notDeletedTicketClasses(state),
      groupedTickets: selectors.ticketsByGroup(state),
      ticketGroups: selectors.sortedTicketGroups(state),
      allTicketGroups: selectors.ticketGroups(state),
      promoCodes: selectors.notDeletedPromoCodes(state),
      allPromoCodes: selectors.promoCodes(state),
      questions: selectors.sortedAttendeeQuestions(state),
      defaultQuestions: selectors.defaultAttendeeQuestions(state),
      allQuestions: selectors.attendeeQuestions(state),
      settings: selectors.settings(state),
      haveNoTickets: selectors.haveNoTickets(state)
    });


    const mapDispatchToProps = dispatch => ({
      ticketChanged(ticket_id, name, value) { return dispatch(Actions.changeTicketClass({id: ticket_id, name, value})); },
      addTicketClass() { return dispatch(Actions.addTicketClass()); },
      removeTicketClass(ticket_id) { return dispatch(Actions.removeTicketClass({id: ticket_id})); },
      ticketClassDragStart(item) { return dispatch(Actions.ticketClassDragStart(item)); },
      ticketClassDragFinish(item) { return dispatch(Actions.ticketClassDragFinish(item)); },
      ticketClassDragCancel(item) { return dispatch(Actions.ticketClassDragCancel(item)); },

      ticketClassDragUpdate(item, target_position, target_group_id) {
        return dispatch(Actions.ticketClassDragUpdate({item, target_position, target_group_id}));
      },

      ticketGroupChanged(ticket_group_id, name, value) { return dispatch(Actions.changeTicketGroup({id: ticket_group_id, name, value})); },
      addTicketGroup() { return dispatch(Actions.addTicketGroup()); },
      removeTicketGroup(ticket_group_id) { return dispatch(Actions.removeTicketGroup({id: ticket_group_id})); },
      ticketGroupDragStart(item) { return dispatch(Actions.ticketGroupDragStart(item)); },
      ticketGroupDragFinish(item) { return dispatch(Actions.ticketGroupDragFinish(item)); },
      ticketGroupDragCancel(item) { return dispatch(Actions.ticketGroupDragCancel(item)); },

      ticketGroupDragUpdate(item, target_position) {
        return dispatch(Actions.ticketGroupDragUpdate({item, target_position}));
      },

      promoCodeChanged(promo_code_id, name, value) { return dispatch(Actions.changePromoCode({id: promo_code_id, name, value})); },
      addPromoCode() { return dispatch(Actions.addPromoCode()); },
      removePromoCode(promo_code_id) { return dispatch(Actions.removePromoCode({id: promo_code_id})); },
      addPromoCodeTicketClass(promo_code_id, ticket_class_id) { return dispatch(Actions.promoCodeAddTicketClass({id: promo_code_id, ticket_class_id})); },
      removePromoCodeTicketClass(promo_code_id, ticket_class_id) { return dispatch(Actions.promoCodeRemoveTicketClass({id: promo_code_id, ticket_class_id})); },
      attendeeQuestionChanged(question_id, name, value) { return dispatch(Actions.changeAttendeeQuestion({id: question_id, name, value})); },
      addAttendeeQuestion() { return dispatch(Actions.addAttendeeQuestion()); },
      removeAttendeeQuestion(question_id) { return dispatch(Actions.removeAttendeeQuestion({id: question_id})); },
      attendeeQuestionDragStart(item) { return dispatch(Actions.attendeeQuestionDragStart(item)); },
      attendeeQuestionDragFinish(item) { return dispatch(Actions.attendeeQuestionDragFinish(item)); },
      attendeeQuestionDragCancel(item) { return dispatch(Actions.attendeeQuestionDragCancel(item)); },

      attendeeQuestionDragUpdate(item, target_position) {
        return dispatch(Actions.attendeeQuestionDragUpdate({item, target_position}));
      },

      addAttendeeQuestionChoice(question_id) { return dispatch(Actions.addAttendeeQuestionChoice({question_id})); },
      changeAttendeeQuestionChoice(question_id, index, value) { return dispatch(Actions.changeAttendeeQuestionChoice({question_id, index, value})); },
      removeAttendeeQuestionChoice(question_id, index) { return dispatch(Actions.removeAttendeeQuestionChoice({question_id, index})); },
      attendeeQuestionChoiceDragStart(question_id, item) { return dispatch(Actions.attendeeQuestionChoiceDragStart({question_id, item})); },
      attendeeQuestionChoiceDragUpdate(question_id, item, index) { return dispatch(Actions.attendeeQuestionChoiceDragUpdate({question_id, item, index})); },
      attendeeQuestionChoiceDragFinish(question_id, result, item) { return dispatch(Actions.attendeeQuestionChoiceDragFinish({question_id, item, result})); },
      attendeeQuestionChoiceDragCancel(question_id, item) { return dispatch(Actions.attendeeQuestionChoiceDragCancel({question_id, item})); }
    });

const DraggableEditor = ReactDnD.DragDropContext(ReactDnDHTML5Backend)(Editor);
export const RegistrationEditor = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(DraggableEditor);
